define(function (require) {


    //IIFE
    const DataModelStore = (function () {

      const BRACKET = 'bracket';
      const GET_FN = 'getFn';
      const SET_FN = 'setFn';

        if (App && App.hasOwnProperty('CivicsStore') !== true ) {
          App.CivicsStore = {};
        }

        //chances are namespace will always be the portletId
        const get = (namespace, key) => {

          let currentNamespace = App.CivicsStore[namespace];

          if (key && currentNamespace)
            return currentNamespace[key];

          //star means the caller does not know what namespace the model resides.
          if(namespace === '*' && key) {
            let modelFound = null;

            for (let name of Object.keys(App.CivicsStore)) {
              let currentProperty = App.CivicsStore[name];
              if (typeof currentProperty === 'object' && currentProperty.hasOwnProperty(key)) {
                modelFound = currentProperty[key];
                break;
              }
            }
            return modelFound;
          }

          return currentNamespace
        }

        //Adds an entry of the model in the store.
        const set = (namespace, key, value) => {
          let currentNamespaceValue = get(namespace);

          if (currentNamespaceValue === undefined){
            App.CivicsStore[namespace] = {}
            currentNamespaceValue = get(namespace);
          }

          currentNamespaceValue[key] = value;
        }
      
        const getModelPropertyValue = (namespace, modelName, propertyKey) => {
          let model = get(namespace, modelName);
          let propertyAccessor = _getPropertyAccessor(model);
          let retValue = '';

          if (model && propertyKey) {
            let keysArr = propertyKey.split('.');

            if (keysArr.length > 1) {
              retValue = _getNestedProperty[propertyAccessor](model, keysArr);
            } else {
              retValue = _getProperty[propertyAccessor](model, propertyKey);
            }
          }

          return retValue;
        }
        
        const _getPropertyAccessor = (model) => {
          let retValue = BRACKET;

          if (model && typeof model.get === 'function') 
            retValue = GET_FN;

          return retValue;
        }

        let _getProperty = {
          bracket: (model, key) => model[key],
          getFn: (model, key) => model.get(key)          
        }

        let _getNestedProperty = {
          bracket: (model, keys) => keys.reduce((prevObj, key) => prevObj && prevObj[key] !== undefined ? prevObj[key] : '', model),
          getFn: (model, keys) => keys.reduce((prevObj, key) => prevObj && prevObj.get(key) !== undefined ? prevObj.get(key) : '', model) 
        }

        const updateModelProperty = (namespace, modelName, propertyKey, value) => {
          let modelToUpdate = get(namespace, modelName);
          let propertySetter = _propertySetter(modelToUpdate);

          if (modelToUpdate && propertyKey) {
            let keysArr = propertyKey.split('.');

            if (keysArr.length > 1) {
              return; //todo:nested challenge?
            }

            _setProperty[propertySetter](modelToUpdate, propertyKey, value);
          }

        }

        const _propertySetter = (model) => {
          let retValue = BRACKET;

          if (typeof model.set === 'function') 
            retValue = SET_FN;

          return retValue;
        }

        let _setProperty = {
          bracket: (modelToUpdate, key, value) => modelToUpdate[key] = value,
          setFn: (modelToUpdate, key, value) => modelToUpdate.set(key, value, {silent: true})
        }

        return {
          get: get,
          set: set,
          updateProperty: updateModelProperty,
          getPropertyValue: getModelPropertyValue
        };
    })();

    return DataModelStore;
});
